let  Dictionary = function()
{
    this.m_dict = {};
}

Dictionary.prototype.Set =function()
{
    this.m_dict = {};
}

Dictionary.prototype.initWidthArray = function(array)
{
    for(var i = 0; i < array.length; ++i)
    {
        this.m_dict[i.toString()] = array[i];
    }
}
Dictionary.prototype.removeAllObjects = function()
{
    this.m_dict = {};
}
Dictionary.prototype.setObject = function(key,value)
{
    this.m_dict[key] = value;
}
Dictionary.prototype.isExistKey = function(key)
{
    if(key in this.m_dict)
    {
        return true;
    }
    return false;
}
Dictionary.prototype.safeGetObject = function(key)
{
    if(this.isExistKey(key))
    {
        return this.m_dict[key];
    }
    return null;
}
Dictionary.prototype.count = function()
{
    var num = 0;
    for(var _ in this.m_dict)
    {
        num++;
    }
    return num;
}
Dictionary.prototype.removeObjectForKey = function(key)
{
    if(this.isExistKey(key))
    {
        var value = this.m_dict[key];
        delete this.m_dict[key];
        return value;
    }
    return null;
}
Dictionary.prototype.forEach = function(call)
{
    for(var key in this.m_dict)
    {
        call(key,this.m_dict[key]);
    }
}
Dictionary.prototype.forBreakEach = function(call)
{
    for(var key in this.m_dict)
    {
        if(call(key,this.m_dict[key]))
        {
            break;
        }
    }
}
Dictionary.prototype.isHavaObject = function(obj)
{
    for(var key in this.m_dict)
    {
        if(this.m_dict[key] == obj)
        {
            return true;
        }
    }
    return false;
}
export  {Dictionary};



//////////////////
// WEBPACK FOOTER
// ./untils/Dictionary.js
// module id = 6frM
// module chunks = 0